import * as types from '../mutation-types'
// import axios from '@/utils/axios'
// import swal from 'vue-sweetalert2'
// initial state
const state = {
  deliveryShippers: null,
  couriers: null
}

const getters = {
  deliveryShippers: state => state.deliveryShippers,
  couriers: state => state.couriers,
  deliveryQuotations: state => state.deliveryQuotations
}

// actions
const actions = {
  fetchDeliveryOptionList () {

  }
}

// mutations
const mutations = {
  [types.FETCH_DELIVERY_OPTION_LIST] (state, response) {
    if (response) {
      state.deliveryShippers = response.data
      state.couriers = response.data
    }
  },
  [types.DELIVERY_QUOTATION_LIST] (state, data) {
    state.deliveryQuotations = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
